export default __webpack_public_path__ + "static/02-01-teach-simulate-tools-2e8d91b2c8dac767413698e0b017eb7f.mp4";